document.addEventListener('DOMContentLoaded', function() {
    // Product gallery thumbnails
    const thumbnails = document.querySelectorAll('.product-gallery--media-thumbnail');
    if (thumbnails.length > 0) {
        let cols = '';
        const count = thumbnails.length;
        if (count >= 7) cols = 'cols_2';
        if (count >= 13) cols = 'cols_3';
        if (count >= 19) cols = 'cols_4';

        if (cols !== '') {
            const gallery = document.querySelector('.product-gallery');
            if (gallery) {
                gallery.classList.add(cols);
            }
        }
    }
});
